<template>
    <div>
        <ion-card class="-light">
            <ion-list-header>Unfallereignis</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col size="12">
                        <base-datetime
                            label="Datum *"
                            :value="unfallDatum"
                            id="unfall-datum"
                            @input="$emit('update:unfallDatum', $event)"
                        ></base-datetime>
                    </ion-col>
                    <ion-col size="12">
                        <base-datetime
                            label="Uhrzeit *"
                            :value="unfallUhrzeit"
                            id="unfall-uhrzeit"
                            @input="$emit('update:unfallUhrzeit', $event)"
                            displayFormat="HH:mm"
                            pickerFormat="HH:mm"
                        ></base-datetime>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-card class="-light">
            <ion-list-header>Unfallort</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-item lines="none">
                            <base-checkbox
                                id="is-home-address"
                                v-model="isHomeAddress"
                            ></base-checkbox>
                            <ion-label>Ort ist Heimadresse</ion-label>
                        </ion-item>
                    </ion-col>
                </ion-row>
                <div v-if="!isHomeAddress">
                    <ion-row>
                        <ion-col size="8">
                            <base-input
                                id="unfall-strasse"
                                type="text"
                                :value="unfallStrasse"
                                label="Straße *"
                                @input="$emit('update:unfallStrasse', $event)"
                            ></base-input>
                        </ion-col>
                        <ion-col size="4">
                            <base-input
                                id="unfall-hausnr"
                                type="text"
                                :value="unfallHausnr"
                                label="Hausnr. *"
                                @input="$emit('update:unfallHausnr', $event)"
                            ></base-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="4">
                            <base-input
                                id="unfall-stiege"
                                type="text"
                                :value="unfallStiege"
                                label="Stiege"
                                @input="$emit('update:unfallStiege', $event)"
                            ></base-input>
                        </ion-col>
                        <ion-col size="4">
                            <base-input
                                id="unfall-stock"
                                type="text"
                                :value="unfallStock"
                                label="Stock"
                                @input="$emit('update:unfallStock', $event)"
                            ></base-input>
                        </ion-col>
                        <ion-col size="4">
                            <base-input
                                id="unfall-tuer"
                                type="text"
                                :value="unfallTuer"
                                label="Tür"
                                @input="$emit('update:unfallTuer', $event)"
                            ></base-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="12">
                            <base-input
                                id="unfall-plz"
                                inputmode="decimal"
                                type="number"
                                :value="unfallPlz"
                                label="PLZ *"
                                @input="$emit('update:unfallPlz', $event)"
                            ></base-input>
                        </ion-col>
                        <ion-col size="12">
                            <base-input
                                id="unfall-ort"
                                type="text"
                                :value="unfallOrt"
                                label="Ort *"
                                @input="$emit('update:unfallOrt', $event)"
                            ></base-input>
                        </ion-col>
                    </ion-row>
                </div>
                <ion-row>
                    <ion-col>
                        <base-input
                            id="unfall-land"
                            type="text"
                            :value="unfallLand"
                            label="Land"
                            @input="$emit('update:unfallLand', $event)"
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-card class="-light">
            <ion-list-header>Unfallbeschreibung</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <base-textarea
                            id="unfall-beschreibung"
                            :value="unfallBeschreibung"
                            label="Was ist passiert? *"
                            @input="$emit('update:unfallBeschreibung', $event)"
                        ></base-textarea>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
    </div>
</template>

<script>
import BaseInput from "./BaseInput";
import BaseTextarea from "./BaseTextarea";
import BaseDatetime from "./BaseDatetime";
import BaseCheckbox from "./BaseCheckbox";

export default {
    components: {
        BaseInput,
        BaseTextarea,
        BaseDatetime,
        BaseCheckbox,
    },
    data() {
        return {
            isHomeAddress: false,
        };
    },
    mounted() {},
    watch: {
        isHomeAddress(value) {
            if (value) {
                this.$emit("place-is-home-address");
            }
        },
    },
    props: {
        unfallDatum: {
            required: true,
            type: String,
        },
        unfallUhrzeit: {
            required: true,
            type: String,
        },
        unfallStrasse: {
            required: true,
            type: String,
        },
        unfallHausnr: {
            required: true,
            type: String,
        },
        unfallStiege: {
            required: true,
            type: String,
        },
        unfallStock: {
            required: true,
            type: String,
        },
        unfallTuer: {
            required: true,
            type: String,
        },
        unfallPlz: {
            required: true,
            type: String,
        },
        unfallOrt: {
            required: true,
            type: String,
        },
        unfallLand: {
            required: true,
            type: String,
        },
        unfallBeschreibung: {
            required: true,
            type: String,
        },
    },
};
</script>

<style></style>
